import React from "react";

function Callout({ children }) {
  return <blockquote className="ee-callout">{children}</blockquote>;
}

export default Callout;
